exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".HeartButton-5fdd6e65{transition:all 0.25s ease}.HeartButton-5fdd6e65 *{color:#FA6400;display:flex;align-items:center;justify-content:center}.HeartButton-5fdd6e65:hover *{color:#fff}\n", ""]);

// Exports
exports.locals = {
	"HeartButton": "HeartButton-5fdd6e65"
};